import { User, Permission } from '../types';

export type NavKey =
  | 'dashboard'
  | 'bookings'
  | 'trips'
  | 'boarding'
  | 'housing'
  | 'buses'
  | 'accommodations'
  | 'cash-closing'
  | 'reports'
  | 'users'
  | 'settings';

/** Minimal menus by role — boarding staff should not see the full system. */
const NAV_BY_ROLE: Record<string, NavKey[] | 'all'> = {
  super_admin: 'all',
  admin: 'all',
  operations: ['dashboard', 'boarding', 'trips'],
  hotel_rep: ['dashboard', 'housing'],
  accounting: ['dashboard', 'bookings', 'cash-closing', 'reports'],
};

export function getAllowedNavKeys(role?: string | null): NavKey[] | 'all' {
  if (!role) return ['dashboard'];
  return NAV_BY_ROLE[role] || ['dashboard'];
}

export function canSeeNav(role: string | undefined | null, key: NavKey): boolean {
  const allowed = getAllowedNavKeys(role);
  return allowed === 'all' || allowed.includes(key);
}

export function hasModulePermission(
  user: User | null | undefined,
  module: Permission['module'],
  action: Permission['actions'][number] = 'read'
): boolean {
  if (!user) return false;
  if (user.role === 'super_admin' || user.role === 'admin') return true;
  return (user.permissions || []).some(
    (p) => p.module === module && (p.actions || []).includes(action)
  );
}

/** Home path after login — always the personal dashboard */
export function getHomePathForRole(_role?: string | null, isVendor = true): string {
  return isVendor ? '/vendor' : '/';
}
